export default [
  {
    path: '/reservations',
    name: 'reservations',
    component: () => import('@/views/hotels/index'),
    meta:  {pageTitle: 'hotels', breadcrumb: [{ text: 'Hotels_Reservations' , active: true }], permission: 'access_tab_hotels' }
  },
  {
    path: '/reservations/add',
    name: 'new_reservations',
    component: () => import('@/views/hotels/add'),
    meta:  {pageTitle: 'hotels', navActiveLink:'reservations', breadcrumb: [{ text: 'Hotels_Reservations', to:'/reservations' }, {text: 'add' , active: true }], permission: 'access_tab_hotels' }
  },
  {
    path: '/reservation/:id',
    name: 'show_reservation',
    component: () => import('@/views/hotels/show'),
    meta:  {pageTitle: 'hotels', navActiveLink:'reservations', breadcrumb: [{ text: 'Hotels_Reservations', to: '/reservations' } , {text:'show' , active:true}], permission: 'access_tab_hotels' }
  },
]